module.exports = __webpack_public_path__ + "img/icon_salary_active.a2fe5f75.png";